import ReactMarkdown from 'react-markdown';

type MarkdownProps = {
    children: string;
}

export const Markdown = ({ children }: MarkdownProps) => {
    return (
        <ReactMarkdown
            children={children}
            components={{
                h1: ({ ...props }) => <h1 className={'my-4 text-2xl font-black'} {...props} />,
                h2: ({ ...props }) => <h2 className={'my-3 text-xl font-bold'} {...props} />,
                h3: ({ ...props }) => <h3 className={'my-2 text-lg font-semibold'} {...props} />,
                h4: ({ ...props }) => <h4 className={'my-1 text-md font-semibold'} {...props} />,
                p: ({ ...props }) => <p className={'block'} {...props} />,
                ul: ({ ...props }) => <ul className={'list-disc list-inside pl-5'} {...props} />
            }} />
    );
};
